export default __webpack_public_path__ + "static/media/halfstar.b86bdd10.svg";